/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import {
    bool,
    object, shape, string,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ReactMarkdown from 'react-markdown';
import { useSelector } from 'react-redux';
import { getFeatureFlag } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const styles = (theme) => ({
    substitutionContainer: {
        margin: '10px 0 10px 120px',
        backgroundColor: theme.palette.cms?.substitutionMesssageBg || '#F6F3F8',
        padding: '10px',
        borderRadius: '5px',
        [theme?.breakpoints?.down('md')]: {
            margin: '0px',
        },
        '& p': {
            margin: '0px',
            [theme?.breakpoints?.down('sm')]: {
                fontSize: '12px',
            },
        },
    },
    substitutionWrapper: {
        background: 'none',
        fontSize: '14px',
        lineHeight: '24px',
        padding: '8px 16px 10px',
        '& p': {
            fontSize: '14px',
            color: '#555555',
        },
        [theme?.breakpoints?.up('600')]: {
            margin: '0px',
            lineHeight: '22px',
            padding: '8px 24px 10px',
        },
    },
    pdpSubstitution: {
        [theme?.breakpoints?.down('600')]: {
            padding: '8px 16px 2px',
            lineHeight: '24px',
        },
    },
});

const  SubstitutionMessage = ({
    classes, content, presentationFamily, data, productBaseContent, isPdpRedesignEnabled, showProductTitleTop,
}) => {
    const productType = data?.availability?.productDeliveryType || '';
    const productSubstitutionMessage = productBaseContent?.entries?.[0]?.substitution?.substitution_message;
    const substitutionInfo = productSubstitutionMessage || content?.entries?.[0]?.substitution?.substitution_message;
    const cleanSubstitutionInfo = substitutionInfo?.replace(/[\u2028|\u2029]/g, ''); // TODO: Remove when data from query doesn't have these characters.
    const substitutionFeatureFlag = useSelector(getFeatureFlag('is-fpt-substitution-message-enabled'));
    const productTypeMessage = productType === 'FPT' ? cleanSubstitutionInfo : productSubstitutionMessage;

    return (
        <>
            {presentationFamily === 'flower' && productTypeMessage && substitutionFeatureFlag
                && (
                    <div className={`${classes.substitutionContainer} ${isPdpRedesignEnabled ? classes.substitutionWrapper : ''} ${showProductTitleTop ? classes.pdpSubstitution : ''}`}>
                        <ReactMarkdown source={productTypeMessage} />
                    </div>
                )}
        </>
    );
};

SubstitutionMessage.propTypes = {
    content: shape({
        substitution: shape({
            substitution_message: string,
        }),
    }),
    data: shape({
        availability: shape({
            productDeliveryType: string,
        }),
    }),
    productBaseContent: shape({
        substitution: shape({
            substitution_message: string,
        }),
    }),
    classes: object.isRequired,
    presentationFamily: string.isRequired,
    isPdpRedesignEnabled: bool,
    showProductTitleTop: bool,
};
SubstitutionMessage.defaultProps = {
    content: {},
    data: {},
    productBaseContent: {},
    isPdpRedesignEnabled: false,
    showProductTitleTop: false,
};
export default  withStyles(styles)(SubstitutionMessage);
